import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./StoryCard";
import laptopImg from "../../Assets/robot_birds.jpg";




function Story() {

   return (
   
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Our <strong className="purple">Story </strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
             <img src={laptopImg} alt="about" className="img-fluid" />
          
            </Col>
      
                  
      
        </Row>
        <h1 className="project-heading">
          Our  <strong className="purple">Core Values </strong>
        </h1>

        <Techstack />

      </Container>
    </Container>
  

  );
}

export default Story;
